import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Check, ChevronRight } from 'lucide-react';
const tomos = [{
  id: 'T1',
  title: 'Fundamentos y Metodología',
  description: 'Todo lo que necesitás saber para enseñar ritmos latinos de forma profesional, clara y progresiva desde el primer día.',
  content: ['Qué es enseñar ritmos latinos vs bailar', 'Perfiles de alumno: principiante, intermedio, avanzado', 'Estructura de clase ideal: calentamiento, desarrollo y cierre', 'Elementos del ritmo: tiempo, compás y fraseo musical aplicado', 'Lenguaje corporal docente: cómo demostrar, corregir y motivar', 'Gestión del grupo: clases numerosas, mixtas y de distintos niveles', 'Glosario técnico para usar con alumnos']
}, {
  id: 'T2',
  title: 'Salsa y Merengue Resueltos',
  description: 'Los dos ritmos más enseñados, completamente estructurados con progresiones didácticas y clases listas para dar desde el día 1.',
  content: ['Historia y contexto de ambos ritmos', 'Elementos técnicos de Salsa: pasos base, tiempo, giros y combinaciones', 'Progresión de Salsa en 3 niveles con secuencias didácticas', 'Elementos técnicos de Merengue: pasos base, caderas y desplazamientos', 'Progresión de Merengue en 3 niveles con secuencias didácticas', '4 clases completas listas combinando ambos ritmos']
}, {
  id: 'T3',
  title: 'Bachata y Cumbia Resueltas',
  description: 'Los ritmos con mayor demanda en Argentina, listos para enseñar con estructura, progresión y clases armadas.',
  content: ['Historia y contexto de ambos ritmos', 'Elementos técnicos de Bachata: pasos base, caderas, giros y conexión', 'Progresión de Bachata en 3 niveles con secuencias didácticas', 'Elementos técnicos de Cumbia: pasos base, variantes regionales y desplazamientos', 'Progresión de Cumbia en 3 niveles con secuencias didácticas', '4 clases completas listas combinando ambos ritmos']
}, {
  id: 'T4',
  title: 'Reggaeton y Ritmos Urbanos Resueltos',
  description: 'El género más demandado hoy, con metodología clara, progresiones adaptadas y clases listas para grupos de cualquier perfil.',
  content: ['Origen urbano, evolución y fusiones actuales', 'Elementos técnicos de Reggaeton: base rítmica, caderas, perreo fitness y movimientos urbanos', 'Progresión didáctica en 3 niveles adaptados a clases grupales', 'Dembow y afrobeats aplicados a clases de fitness', 'Cómo adaptar para distintos públicos: adultos mayores, jóvenes y mixtos', '4 clases completas temáticas listas']
}, {
  id: 'T5',
  title: 'Planificación Anual y Mensual',
  description: 'El tomo que resuelve el problema número uno del instructor de ritmos latinos: dejá de improvisar para siempre.',
  content: ['Por qué planificar y su impacto en la retención de alumnos', 'Sistema de planificación anual: cómo distribuir ritmos y contenidos en 12 meses', '4 meses completos desarrollados y listos para usar', 'Cómo adaptar la planificación para gimnasio, academia e independiente', 'Fichas de registro y seguimiento del progreso de alumnos', 'Cómo evaluar y ajustar tu planificación cuando algo no funciona']
}, {
  id: 'T6',
  title: 'Clases Temáticas y Recursos Especiales',
  description: 'El diferencial que te va a separar de cualquier otro instructor de ritmos latinos en tu zona.',
  content: ['Clase de carnaval, clase retro y clase fusión completas y listas', 'Clases para fechas especiales: Día de la Madre, fin de año y verano', '10 calentamientos rítmicos específicos para ritmos latinos', '8 cierres de clase con movimiento suave y vuelta a la calma', 'Cómo explicar tu metodología a nuevos alumnos', 'Checklist completo del instructor antes, durante y después de clase']
}];
export function TomosSlider() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <section className="py-12 md:py-24 bg-neutral-900 border-t border-neutral-800" data-id="element-329">
      <div className="container mx-auto px-4 mb-6 md:mb-12 text-center" data-id="element-330">
        <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-331">
          LOS 6 TOMOS
        </h2>
        <p className="text-sm md:text-xl text-neutral-400" data-id="element-332">
          Para profes de ritmos latinos de todos los niveles y enfoques
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4" data-id="element-333">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-334">
          {tomos.map(tomo => {
          const isExpanded = expandedId === tomo.id;
          return <motion.div key={tomo.id} layout onClick={() => setExpandedId(isExpanded ? null : tomo.id)} className={`cursor-pointer rounded-xl md:rounded-2xl border transition-colors duration-300 ${isExpanded ? 'col-span-2 lg:col-span-1 bg-neutral-950 border-red-500/50 shadow-[0_0_30px_rgba(220,38,38,0.15)]' : 'bg-neutral-900 border-neutral-800 hover:border-neutral-700'}`} data-id="element-335">
                <div className="p-3.5 md:p-8" data-id="element-336">
                  <div className="flex items-center gap-2 md:gap-4 mb-2 md:mb-4" data-id="element-337">
                    <div className={`flex items-center justify-center w-9 h-9 md:w-12 md:h-12 rounded-lg md:rounded-xl font-black text-sm md:text-xl ${isExpanded ? 'bg-red-600 text-white' : 'bg-neutral-800 text-neutral-400'}`} data-id="element-338">
                      {tomo.id}
                    </div>
                    <BookOpen className={`w-4 h-4 md:w-6 md:h-6 ${isExpanded ? 'text-red-500' : 'text-neutral-600'}`} data-id="element-339" />
                  </div>

                  <h3 className={`font-bold mb-1 md:mb-2 text-sm md:text-xl leading-snug ${isExpanded ? 'text-lg md:text-2xl text-white' : 'text-neutral-200'}`} data-id="element-340">
                    {tomo.title}
                  </h3>

                  <AnimatePresence data-id="element-341">
                    {isExpanded && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} exit={{
                  opacity: 0,
                  height: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-342">
                        <p className="text-neutral-400 mb-6 mt-4 leading-relaxed" data-id="element-343">
                          {tomo.description}
                        </p>
                        <div className="bg-neutral-900 rounded-xl p-6 border border-neutral-800" data-id="element-344">
                          <h4 className="text-sm font-bold text-neutral-500 uppercase tracking-wider mb-4" data-id="element-345">
                            Contenido:
                          </h4>
                          <ul className="space-y-3" data-id="element-346">
                            {tomo.content.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-neutral-300" data-id="element-347">
                                <Check className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-348" />
                                <span data-id="element-349">{item}</span>
                              </li>)}
                          </ul>
                        </div>
                      </motion.div>}
                  </AnimatePresence>

                  {!isExpanded && <div className="mt-2 md:mt-4 text-xs md:text-sm font-medium text-red-500 flex items-center gap-1" data-id="element-350">
                      Ver contenido{' '}
                      <ChevronRight className="w-3 h-3 md:w-4 md:h-4" data-id="element-351" />
                    </div>}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}